export const plethorePalette: string[] = [
  '#e9ece8',
  '#d3d8d1',
  '#bdc4ba',
  '#a7b0a3',
  '#919c8c',
  '#7b8875',
  '#65745e',
  '#4f6047',
  '#5a6b52',
  '#65765d',
]
export const tuttiFruttiPalette: string[] = [
  // Verts naturels
  '#7a8875',
  '#a5b09c',
  '#6b7866',
  '#9ca896',
  '#85907e',
  '#b4bfb1',
  '#8f9a8c',
  '#a8b3a5',

  // Beiges et terres
  '#a39f93',
  '#b8b4a8',
  '#8e8a7e',
  '#c4c0b4',
  '#99958a',
  '#aea89d',
  '#bfbbb0',

  // Gris-bleus doux
  '#8c9294',
  '#9ba5a7',
  '#adb7b9',
  '#8a9496',

  // Oranges désaturés / terres cuites
  '#b39a88',
  '#a8917f',
  '#c4b5a8',
  '#9a8474',
  '#b5a699',

  // Violets parme doux
  '#a094a3',
  '#b5a9b8',
  '#8d8292',
  '#9e92a1',
  '#c4b8c7',

  // Roses poussiéreux
  '#b3999f',
  '#a88e94',
  '#c4b0b6',
  '#9d8389',
  '#b8a4aa',

  // Jaunes doux / ocres
  '#b5ab8e',
  '#a89e82',
  '#c4baad',
  '#9a9076',
  '#afa594',
]
